import styled from 'styled-components';

export const StyledPriorityContainer = styled.div`
  ion-item::part(native) {
    padding: 0;
    background-color: transparent;
  }
`;
